import * as React from 'react';
import classnames from "classnames";

import { EditCreateDivisionStoreState } from "./EditCreateDivisionStore";
import { EditCreateDivisionActions } from "./EditCreateDivisionActions";
import { DivisionSelector } from "../../DivisionSelector";
import { LoadableGroup, InputTextGroup } from "../../Forms/Groups";
import { Polyglot } from '../../../../polyglot';

const styles = require('./EditCreateDivision.scss');

interface FormProps
{
    polyglot: Polyglot;
    loadingDivisions: boolean;
}

// Partial because these props will be injected
type Props = EditCreateDivisionStoreState & Partial<EditCreateDivisionActions> & FormProps;

// This is an edit form for Divisioin entity
export class EditCreateDivision extends React.Component<Props>
{
    render()
    {
        const { draft, polyglot } = this.props;
        return (
            <div className={classnames("form-horizontal", styles.EditCreateDivision)}>
                <LoadableGroup title={`${polyglot.t('division.parent_label')}:`} value={draft.ParentName} isLoading={this.props.loadingDivisions}>
                    <DivisionSelector divisions={this.props.divisions} onChange={d => this.props.setParentDivision(d ? d.id : null)} selectedId={draft.ParentId} />
                </LoadableGroup>
                <InputTextGroup title={`${polyglot.t('division.name_label')}:`} value={draft.Name} disabled={true} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/EditCreateDivision.tsx